import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient instance used app-wide. Defaults are tuned for
 * a small content site:
 *   - 5 min staleTime: rarely-changing public content (services,
 *     blogs, courses) can be served from cache without refetching.
 *   - 30 min gcTime: keep cached data even if no observers for half
 *     an hour, so quick navigation back to a page is instant.
 *   - 1 retry: networks blip, but don't pile up on real failures.
 *   - refetchOnWindowFocus disabled: too aggressive for public pages.
 *   - refetchOnReconnect kept on: useful after the laptop sleeps.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
